<template>
    <div>
        <modal class="add-equips" :display="modalStatus.bizAddEquips" @modalStatus="closeModal" >
            <h1>新增設備</h1>
            <div class="add-equips-wrap">
                <div class="content">
                    <div class="equips-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill">*</span>
                                設備名稱
                            </div>
                            <span v-show="error.name" class="error-with-title">{{error.name}}</span>
                        </label>
                        <div class="input-arear">
                            <input :class="{error: error.name}" type="text" v-model="equip.name" placeholder="輸入設備名稱">
                        </div>
                    </div>
                    <div class="equips-input">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                設備數量
                            </div>
                            <!-- <span v-show="error.equips" class="error-with-title">{{error.equips}}</span> -->
                        </label>
                        <div class="input-arear">
                            <input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" v-model.number="equip.count" placeholder="輸入設備數量">
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setEquips()">確定</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

import { 
    apiSetNickName
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            equip: {
                name: null,
                count: null
            },
            error: {
                name: null
            }
        }
    },
    destroyed(){
    },
    watch: {
        nickName: function (val) {
            this.checkInput()
        },
        // 'modalStatus.bizAddEquips': function (val) {
        //     console.log(val)
        //     if(val){
        //         this.$analytics.logEvent('新增出租人姓名', { screen_name: '新增出租人姓名'})
        //     }
        // }
    },
    methods: {
        setEquips: function () {
            if(this.checkInput()){
                this.$emit('setEquips', this.equip)
                this.closeModal()
            }
        },
        checkInput: function () {
            if(this.equip.name){
                this.error.name = ''
                return true
            }else{
                this.error.name = '請輸入設備名稱'
                return false
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizAddEquips'})
            this.equip.name = null
            this.equip.count = null
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss">
    #modal.add-equips{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .add-equips-wrap{
                    width: 384px;
                    padding: 0 32px 0 32px;
                    .content{
                        margin-bottom: 40px;
                        .equips-input{
                            margin-bottom: 24px;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/addEquips.vue